import { render } from "./KeyResultForm.vue?vue&type=template&id=d4518de6&scoped=true"
import script from "./KeyResultForm.vue?vue&type=script&lang=js"
export * from "./KeyResultForm.vue?vue&type=script&lang=js"

import "./KeyResultForm.vue?vue&type=style&index=0&id=d4518de6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4518de6"

export default script